module.exports = __webpack_public_path__ + "img/LA.027bfe9e.png";